import React from 'react';
import styled from '@emotion/styled';
import PropTypes, { InferProps } from 'prop-types';
import SearchField from '../SearchField';
import breakpoints from '../Theme/breakpoints';

const SearchFilterWrapper = styled.div`
  margin: 0 0 20px;
  padding: 0 0 4px;
  display: flex;
  flex-wrap: wrap;

  @media (min-width: ${breakpoints.md}px) {
    margin: 0 0 32px;
  }
`;

const FullWidthSearchField = styled(SearchField)`
  width: 100%;
  font-size: 0.85rem;

  &.MuiFormControl-root {
    margin: 0 12px;
  }

  @media (min-width: ${breakpoints.md}px) {
    &.MuiFormControl-root {
      margin: 0;
    }
  }
`;

const searchFilterPropertyTypes = {
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  search: PropTypes.string,
};

type SearchFilterProperties = InferProps<typeof searchFilterPropertyTypes>;

const SearchFilter = ({
  label,
  search = '',
  onChange,
  onClear,
}: SearchFilterProperties) => (
  <SearchFilterWrapper>
    <FullWidthSearchField
      id="products-search"
      label={label}
      value={search}
      onChange={onChange}
      onClear={onClear}
    />
  </SearchFilterWrapper>
);

SearchFilter.propTypes = searchFilterPropertyTypes;

export default SearchFilter;
